// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bRNdv","badges":"styles_badges__2cXSG"};